export function parseServerError(error?: any): string {
	let msg;
	if (error?.response?.data?.message) msg = error.response.data.message + ''
	else if (error?.data?.message) msg = error.data.message + ''
	else if (error?.message) msg = error.message + ''
	else if (error) msg = error + ''
	if (msg) msg = msg.replace(/\\n/g, '\n')
	return msg || ''
}